

























import Component from 'vue-class-component';
import Header from '@/components/header/header.component.ts';

@Component
export default class B2BHeader extends Header {
}

